import React from 'react';
import Icon from '../../../components/AppIcon';

const BenchmarkComparison = ({ title, data }) => {
  const getPerformanceColor = (performance) => {
    if (performance >= 90) return 'text-success';
    if (performance >= 70) return 'text-warning';
    return 'text-error';
  };

  const getPerformanceIcon = (performance) => {
    if (performance >= 90) return 'TrendingUp';
    if (performance >= 70) return 'Minus';
    return 'TrendingDown';
  };

  const getBarColor = (performance) => {
    if (performance >= 90) return 'bg-success';
    if (performance >= 70) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 card-shadow">
      <h3 className="text-lg font-semibold text-foreground mb-6">{title}</h3>
      <div className="space-y-6">
        {data?.map((item, index) => (
          <div key={index} className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="flex items-center space-x-2">
                  <span className="text-sm font-medium text-foreground">{item?.metric}</span>
                  <Icon 
                    name={getPerformanceIcon(item?.performance)} 
                    size={16} 
                    className={getPerformanceColor(item?.performance)}
                  />
                </div>
              </div>
              <div className="text-right">
                <div className={`text-lg font-bold ${getPerformanceColor(item?.performance)}`}>
                  {item?.value}
                </div>
                <div className="text-xs text-muted-foreground">
                  vs {item?.benchmark}
                </div>
              </div>
            </div>
            
            <div className="space-y-2">
              <div className="flex justify-between text-xs text-muted-foreground">
                <span>Performance Score</span>
                <span>{item?.performance}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className={`h-2 rounded-full transition-all duration-300 ${getBarColor(item?.performance)}`}
                  style={{ width: `${item?.performance}%` }}
                />
              </div>
            </div>
            
            {item?.insight && (
              <div className="bg-muted rounded-lg p-3">
                <p className="text-xs text-muted-foreground">{item?.insight}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Overall Performance</span>
          <div className="flex items-center space-x-2">
            <span className="font-medium text-foreground">
              {Math.round(data?.reduce((sum, item) => sum + item?.performance, 0) / data?.length)}%
            </span>
            <span className="text-xs text-muted-foreground">Industry Average</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenchmarkComparison;